import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import type { ChatMessage } from '@/app/KeywordTracker/types/aiModalTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Spinner } from 'react-bootstrap';
import { exportMessagesToCsv } from '../utils/exportMessagesToCsv';

interface AiModalIconActionsProps {
  messages: ChatMessage[];
  keyword?: string;
  isFetchingAnalysis: boolean;
  isResearching: boolean;
  isDeletingHistory: boolean;
  hasKeywordHistory: boolean;
  onDeleteHistory: () => void;
}

const AiModalIconActions = ({
  messages,
  keyword,
  isFetchingAnalysis,
  isResearching,
  isDeletingHistory,
  hasKeywordHistory,
  onDeleteHistory
}: AiModalIconActionsProps) => {
  const isBusy = isFetchingAnalysis || isResearching || isDeletingHistory;
  const canExportCsv = messages.length > 0 && !isFetchingAnalysis;

  return (
    <div className="ai-modal-icon-actions d-flex align-items-center">
      <ChildrensTooltip placement="top" html="خروجی CSV" delayToRemove={0}>
        <span className="ai-modal-icon-action-wrap">
          <Button
            size="sm"
            variant="link"
            className="ai-modal-icon-action ai-modal-icon-action--csv"
            disabled={!canExportCsv}
            onClick={() => exportMessagesToCsv(messages, keyword)}
            aria-label="خروجی CSV"
          >
            <FontAwesomeIcon icon="file-excel" fixedWidth />
          </Button>
        </span>
      </ChildrensTooltip>

      {hasKeywordHistory && (
        <ChildrensTooltip placement="top" html="حذف تاریخچه" delayToRemove={0}>
          <span className="ai-modal-icon-action-wrap">
            <Button
              size="sm"
              variant="link"
              className="ai-modal-icon-action ai-modal-icon-action--danger"
              disabled={isBusy}
              onClick={onDeleteHistory}
              aria-label="حذف تاریخچه"
            >
              {isDeletingHistory ? (
                <Spinner
                  className="ai-modal-icon-action-spinner"
                  animation="border"
                />
              ) : (
                <FontAwesomeIcon icon="trash-alt" fixedWidth />
              )}
            </Button>
          </span>
        </ChildrensTooltip>
      )}
    </div>
  );
};

export default AiModalIconActions;
